import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import BonusOffers from 'core/modules/BonusOffers/BonusOffers';
import BonusOffer from 'core/modules/BonusOffers/components/BonusOffer';

import { selectBonusOffersFlexPageConfig, selectBonusOffers } from './selectors';

import { triggerBonusOffersFlexPageIsViewed, triggerBonusOffersFlexPageSectionIsViewed } from './actions';

import './BonusOffersFlexPage.scss';

function BonusOffersFlexPage({ title }) {
  const config = useSelector(selectBonusOffersFlexPageConfig);
  const bonusOffers = useSelector(selectBonusOffers);
  const dispatch = useDispatch();
  const prevBonusOffers = useRef(bonusOffers);

  const getBonusOffersContent = () => (
    bonusOffers.map(offer => (
      <div className="mn_offerWrap" key={offer.bonusId}>
        <BonusOffer {...offer} config={config} />
      </div>
    ))
  );

  const triggerViewEvent = () => {
    dispatch(triggerBonusOffersFlexPageSectionIsViewed(title, bonusOffers.length));
    bonusOffers.forEach((offer) => {
      dispatch(triggerBonusOffersFlexPageIsViewed(offer));
    });
  };

  useEffect(() => {
    if (!isEmpty(bonusOffers)) {
      triggerViewEvent();
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(bonusOffers) && isEmpty(prevBonusOffers.current)) {
      triggerViewEvent();
    }
    prevBonusOffers.current = bonusOffers;
  }, [bonusOffers]);

  return (
    <BonusOffers>
      {!isEmpty(bonusOffers) && (
        <div className="mn_bonusMerchantOffersFlexPage" data-test="bonus-offer-merchants-wrapper">
          <SectionTitle title={title} useHtmlMarkup />
          <div className={
            `mn_bonusOffersList ${bonusOffers.length > 2
              ? 'mn_offerList4UpDisplay'
              : 'mn_offerList2UpDisplay'}`
            }
          >
            {getBonusOffersContent()}
          </div>
        </div>
      )}
    </BonusOffers>
  );
}

BonusOffersFlexPage.propTypes = {
  title: PropTypes.string.isRequired,
};

export default (props) => <ComponentErrorBoundary><BonusOffersFlexPage {...props} /></ComponentErrorBoundary>;
